import React from 'react';
import PropTypes from 'prop-types';

/**
 * Displays a lozenge badge for menu items with custom label and colors.
 *
 * @function
 * @param       {object} lozenge lozenge object with label, textColour, and backgroundColour.
 * @param       {boolean} isForBaste whether this lozenge is displayed for a baste option.
 * @param       {boolean} isForSide whether this lozenge is displayed for a side item.
 * @constructor
 */
function Lozenge({ lozenge, isForBaste, isForSide }) {
    if (!lozenge) {
        return null;
    }

    const style = {
        backgroundColor: lozenge.backgroundColour,
        borderColor: lozenge.backgroundColour,
        color: lozenge.textColour
    };

    let className = 'flag';
    if (isForBaste) className += ' is-for-baste';
    if (isForSide) className += ' is-for-side';

    return (
        <i className={className} style={style}>
            {lozenge.label}
        </i>
    );
}

export { Lozenge };

Lozenge.propTypes = {
    lozenge: PropTypes.shape({
        label: PropTypes.string,
        textColour: PropTypes.string,
        backgroundColour: PropTypes.string
    }),
    isForBaste: PropTypes.bool,
    isForSide: PropTypes.bool
};
